import { useMutation } from 'react-query';
import { EindomfinansAPI } from '../api';

export const useAuthVerify = () => {
    return useMutation(EindomfinansAPI.authVerify);
};
